<template>
  <div class="login">
    <div class="container">
      <div class="form">
        <div class="title">
          Sign In
        </div>
        <div class="input-wrap">
          <input
            type="text"
            class="input toLowerCase"
            name="email"
            placeholder="Email"
            v-model="email"
            autocomplete="off"
            :class="{ invalid: errors.has('email') }"
            v-validate="'required|email|max:50'"
          />
          <span
            class="validate-error bottom-position"
            v-if="errors.has('email')"
          >
            {{ errors.first("email") }}
          </span>
        </div>
        <div class="input-wrap">
          <input
            type="password"
            class="input"
            name="password"
            @keyup.enter="auth"
            placeholder="Password"
            autocomplete="off"
            v-model="password"
            :class="{ invalid: errors.has('password') }"
            v-validate="'required|min:8'"
          />
          <span class="validate-error" v-if="errors.has('password')">
            {{ errors.first("password") }}
          </span>
        </div>
        <div class="check">
          <label class="checkbox-wrapper" for="remember">
            <span class="checkbox-wrap">
              <input
                type="checkbox"
                id="remember"
                class="checkbox"
                v-model="rememberMe"
              />
              <span class="checkbox-sircle"></span>
            </span>
            <span class="check-text">Remember me</span>
          </label>
          <router-link to="/resetPassword" tag="a" class="reset-pass"
            >Forgot Password?</router-link
          >
        </div>
        <button
          class="btn"
          @click.prevent="$validator.validateAll()"
          @click="auth"
          :disabled="!isComplete"
        >
          Continue
        </button>
        <router-link to="/activate" tag="a" class="have-kit"
          >Need to activate your kit?</router-link
        >
      </div>
      <img src="../images/bg/spinner.png" alt="Spinner" class="spiner" />
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { mapGetters } from "vuex";
import { mapMutations } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      email: "",
      password: "",
      rememberMe: false
    };
  },
  computed: {
    isComplete() {
      return this.email && this.password;
    },
    ...mapGetters(["serverValidation"])
  },
  watch: {
    serverValidation(error) {
      error.forEach(item => {
        this.$validator.errors.add({ field: item.field, msg: item.message });
      });
    }
  },
  methods: {
    ...mapActions(["authentication", "setToken"]),
    ...mapMutations(["clearServerValidationErrors"]),
    auth() {
      if (this.errors.any() || !this.isComplete) {
        return;
      }
      const data = {
        email: this.email.toLocaleLowerCase(),
        password: this.password
      };
      this.authentication({ data: data, rememberMe: this.rememberMe }).then(
        res => {
          this.errors.clear();
          this.clearServerValidationErrors();
          if(res === "customer") {
            this.$router.push({ path: "/home" })
          } else if(res === "laboperator") {
            this.$router.push({ path: "/lab/dashboard" })
          } else if(res === "mtclab") {
            this.$router.push({ path: "/mtclab/dashboard" })
          }else{
            this.$router.push({ path: "/dashboard" });
          }
        }
      ).catch(err => {
          this.clearServerValidationErrors();
          if (err.type === "validation" || err.type === "auth") {
            err.errors.forEach(e => {
              if (e.field === "email") {
                this.emailError = e.message;
              } else if (e.field === "password") {
                this.passwordError = e.message;
              }
            });
          } else {
            this.generalError = err.message;
          }
    });
    }
  }
};
</script>

<style scoped lang="scss">
@import "../styles/colors";
.check-text {
  color: $green;
  margin: 0 0 0 10px;
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
}
.checkbox-wrapper {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.checkbox-wrap {
  position: relative;
  border: 1px solid $green;
  width: 18px;
  height: 18px;
  display: flex;
  justify-content: center;
  border-radius: 50%;
}
.checkbox {
  opacity: 0;
  position: absolute;
  cursor: pointer;
  left: 0;
  top: 0;
  margin: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
}
.checkbox-sircle {
  position: absolute;
  opacity: 0;
  top: 50%;
  transform: translate(0, -50%);
  width: 10px;
  height: 10px;
  background-color: $green;
  border-radius: 100%;
}
.checkbox:checked ~ .checkbox-sircle {
  opacity: 1;
}
.check {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 20px 0 0px;
  color: #fff;
  font-size: 16px;
}
.login {
  max-width: 100%;
  width: 100vw;
  height: auto;
  min-height: calc(100vh - 60px);
  display: flex;
  background-color: transparent;
  padding: 100px 0 0 0;
}
.bottom-position {
  bottom: -22px;
}
.form {
  padding: 36px 80px 40px 80px;
  box-shadow: 0 3px 15px -9px $boxShadow;
  background-color: $white;
  max-width: 550px;
  width: 50%;
  margin: 40px 0 0 auto;
  position: relative;
  border-radius: 15px;
  font-family: TTNormsMedium, sans-serif;
}
.title {
  color: $blue;
  font-family: TTNormsBold, sans-serif;
  font-size: 27px;
  text-align: center;
  margin: 0 0 36px 0;
}
.input-wrap.input {
  border: 1px solid $red;
}
.input {
  padding: 17px 20px;
  color: $gray;
  width: 100%;
  font-size: 16px;
  text-align: center;
  outline: none;
  border-radius: 10px;
  border: 1px solid #cccccc;
  font-family: TTNormsMedium, sans-serif;
}
.input::placeholder {
  color: $lightGray;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
}
.input-wrap {
  margin: 0 0 30px;
}
.btn {
  background-color: $green;
  width: 50%;
  margin: 36px auto 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: 1px solid transparent;
  height: 45px;
  border-radius: 25px;
  font-size: 18px;
  transition: all 0.5s linear;
  font-family: TTNormsBold, sans-serif;
}
.btn:disabled {
  cursor: default;
  opacity: 0.5;
}

.reset-pass {
  color: $green;
  font-size: 14px;
  font-family: TTNormsMedium, sans-serif;
}
.have-kit {
  width: 100%;
  display: flex;
  justify-content: center;
  font-size: 16px;
  font-family: TTNormsMedium, sans-serif;
  color: $green;
  margin-top: 36px;
}
.input.invalid {
  border: 1px solid $red;
}
.input:focus {
  border: 1px solid rgb(77, 144, 254);
}
.input.invalid:focus {
  border: 1px solid rgb(77, 144, 254);
}
.spiner {
  display: none;
}
@media screen and (max-width: 1000px) {
  .form {
    padding: 30px;
    max-width: 450px;
  }
}
@media screen and (max-width: 768px) {
  .login {
    background: url("../images/bg/sky-mobile.jpg");
    padding: 90px 0 0 0;
  }
  .form {
    width: 100%;
    margin: 0 auto;
  }
  .spiner {
    display: flex;
    width: 68px;
    height: 68px;
    margin: 26px auto;
  }
}
@media (max-width: 568px) {
  .form {
    padding: 36px 20px 40px 20px;
  }
  .login {
    padding: 90px 0 0 0;
  }
}
</style>
